"use strict";

var _WeakMap = require("@babel/runtime-corejs3/core-js-stable/weak-map");
var _Object$defineProperty = require("@babel/runtime-corejs3/core-js-stable/object/define-property");
var _Object$getOwnPropertyDescriptor = require("@babel/runtime-corejs3/core-js-stable/object/get-own-property-descriptor");
var _interopRequireDefault = require("@babel/runtime-corejs3/helpers/interopRequireDefault");
_Object$defineProperty(exports, "__esModule", {
  value: true
});
_Object$defineProperty(exports, "_HeaderContents", {
  enumerable: true,
  get: function () {
    return _style.HeaderContents;
  }
});
exports.default = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/extends"));
var _react = _interopRequireWildcard(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _makeStyles = _interopRequireDefault(require("@mui/styles/makeStyles"));
var _Dialog = _interopRequireDefault(require("@mui/material/Dialog"));
var _uiTheme = require("@kyruus/ui-theme");
var _Cancel = _interopRequireDefault(require("@kyruus/react-ikons/Cancel"));
var _style = require("./style");
function _getRequireWildcardCache(e) { if ("function" != typeof _WeakMap) return null; var r = new _WeakMap(), t = new _WeakMap(); return (_getRequireWildcardCache = function (e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = _Object$defineProperty && _Object$getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? _Object$getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? _Object$defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
const ModalComponent = (0, _uiTheme.withMuiThemeAdapter)(_Dialog.default);
const Modal = _ref => {
  let {
    title,
    subtitle,
    body,
    primaryButton,
    secondaryButton,
    onClose,
    useHeaderBorder,
    allowContentOverflow,
    topAligned,
    headerTestId,
    closeBtnTestId,
    hideHeaderCloseButton,
    ...props
  } = _ref;
  const modalBodyRef = (0, _react.useRef)();
  const [showFooterShadow, setShowFooterShadow] = (0, _react.useState)(false);
  const useStyles = (0, _makeStyles.default)({
    paper: allowContentOverflow ? {
      overflowY: 'initial'
    } : {},
    scrollPaper: {
      alignItems: topAligned ? 'baseline' : 'center'
    }
  });
  const hasHeaderText = !!(title || subtitle);
  const hasHeaderContent = hasHeaderText || !hideHeaderCloseButton;
  const onCloseHandler = (e, reason) => {
    if (typeof onClose === 'function') {
      onClose(e, reason);
    }
  };
  const setShadow = (0, _react.useCallback)(() => {
    if (modalBodyRef.current) {
      const hasScroll = modalBodyRef.current.scrollHeight > modalBodyRef.current.clientHeight;
      const isScrollBottom = Math.abs(modalBodyRef.current.scrollHeight - modalBodyRef.current.scrollTop - modalBodyRef.current.clientHeight) < 1;
      setShowFooterShadow(hasScroll && !isScrollBottom);
    }
  }, []);
  (0, _react.useLayoutEffect)(() => {
    let resizeObserver;
    if (typeof window !== undefined && window.ResizeObserver) {
      resizeObserver = new ResizeObserver(() => setShadow());
    }

    // material-ui dialog doesn't register ref until the next frame
    window.requestAnimationFrame(() => {
      setShadow();
      if (modalBodyRef.current) {
        modalBodyRef.current.addEventListener('scroll', setShadow);
        if (resizeObserver) {
          resizeObserver.observe(modalBodyRef.current);
        }
      }
    });
    return () => {
      if (resizeObserver) {
        resizeObserver.disconnect();
      }
      if (modalBodyRef.current) {
        modalBodyRef.current.removeEventListener('scroll', setShadow);
      }
    };
  }, [setShadow, props.open]);
  return /*#__PURE__*/_react.default.createElement(ModalComponent, (0, _extends2.default)({
    classes: useStyles(),
    fullWidth: true,
    PaperProps: {
      'aria-modal': true
    }
  }, props, {
    onClose: onCloseHandler
  }), /*#__PURE__*/_react.default.createElement(_style.StyledModalContainer, {
    allowContentOverflow: allowContentOverflow
  }, /*#__PURE__*/_react.default.createElement(_style.HeaderWrapper, {
    hasHeaderText: hasHeaderText,
    useHeaderBorder: useHeaderBorder
  }, hasHeaderText && /*#__PURE__*/_react.default.createElement(_style.HeaderContents, null, /*#__PURE__*/_react.default.createElement(_style.TitleAndCancelContainer, null, /*#__PURE__*/_react.default.createElement(_style.Title, {
    tabIndex: "-1",
    "data-testid": headerTestId
  }, title)), /*#__PURE__*/_react.default.createElement(_style.Subtitle, null, subtitle)), !hideHeaderCloseButton && /*#__PURE__*/_react.default.createElement(_style.CancelButton, {
    "data-testid": closeBtnTestId,
    onClick: e => onCloseHandler(e, 'closeButtonClick'),
    "aria-label": "Close",
    hasHeaderText: hasHeaderText,
    mode: "flat"
  }, /*#__PURE__*/_react.default.createElement(_Cancel.default, {
    "aria-hidden": "true"
  }))), /*#__PURE__*/_react.default.createElement(_style.StyledBody, {
    allowContentOverflow: allowContentOverflow,
    addTopMargin: useHeaderBorder || !hasHeaderContent,
    ref: modalBodyRef
  }, body), (secondaryButton || primaryButton) && /*#__PURE__*/_react.default.createElement(_style.StyledFooter, {
    showShadow: showFooterShadow
  }, secondaryButton, primaryButton)));
};
Modal.propTypes = {
  /**
   * The body of the modal.
   */
  body: _propTypes.default.node,
  /**
   * Callback fired when the component requests to be closed.
   * The embedding application should use this to set the modal's open property to false.
   * Signature:
      function(event: object, reason: string) => void
      event: The event source of the callback.
      reason: Can be: "closeButtonClick", "escapeKeyDown", or "backdropClick".
     * Consuming application should use these reasons to customize escape key and/or backdrop click behavior.
   */
  onClose: _propTypes.default.func,
  /**
   * The maximum width of the modal box. Use false for fullscreen.
   */
  maxWidth: _propTypes.default.oneOf(['xs', 'sm', 'md', 'lg', 'xl', false]),
  /**
   * Whether or not the modal is currently open
   */
  open: _propTypes.default.bool,
  /**
   * The primary button for the modal. This should be a @kyruus/button.
   * The embedding application should handle styling and click handling.
   */
  primaryButton: _propTypes.default.element,
  /**
   * The secondary button for the modal. This should be a @kyruus/button.
   * The embedding application should handle styling and click handling.
   */
  secondaryButton: _propTypes.default.element,
  /**
   * The title to go in the modal header
   */
  title: _propTypes.default.node,
  /**
   * A subtitle that will appear below the main title.
   */
  subtitle: _propTypes.default.oneOfType([_propTypes.default.string, _propTypes.default.element]),
  /**
   * Display the title within a header container.
   * Set to false for confirmation modals.
   */
  useHeaderBorder: _propTypes.default.bool,
  /**
   * Set to true if you want overflow content to be rendered outside and below the modal's bottom edge.
   */
  allowContentOverflow: _propTypes.default.bool,
  /**
   * If true, the dialog will be full-screen.
   */
  fullScreen: _propTypes.default.bool,
  /**
   * If true, the dialog will render at the top of its container.
   * By default, the dialog renders in the center of its container.
   */
  topAligned: _propTypes.default.bool,
  /**
   * If provided, the dialog header will have this prop applied as a data-testid attr.
   */
  headerTestId: _propTypes.default.string,
  /**
   * If provided, the dialog close button will have this prop applied as a data-testid attr.
   */
  closeBtnTestId: _propTypes.default.string,
  /**
   * If set to true, the header close button will not be rendered
   */
  hideHeaderCloseButton: _propTypes.default.bool
};
Modal.defaultProps = {
  open: false,
  hideHeaderCloseButton: false
};
var _default = exports.default = Modal;
Modal.__docgenInfo = {
  "description": "",
  "methods": [],
  "displayName": "Modal",
  "props": {
    "open": {
      "defaultValue": {
        "value": "false",
        "computed": false
      },
      "description": "Whether or not the modal is currently open",
      "type": {
        "name": "bool"
      },
      "required": false
    },
    "hideHeaderCloseButton": {
      "defaultValue": {
        "value": "false",
        "computed": false
      },
      "description": "If set to true, the header close button will not be rendered",
      "type": {
        "name": "bool"
      },
      "required": false
    },
    "body": {
      "description": "The body of the modal.",
      "type": {
        "name": "node"
      },
      "required": false
    },
    "onClose": {
      "description": "Callback fired when the component requests to be closed.\nThe embedding application should use this to set the modal's open property to false.\nSignature:\n      function(event: object, reason: string) => void\n      event: The event source of the callback.\n      reason: Can be: \"closeButtonClick\", \"escapeKeyDown\", or \"backdropClick\".\n\nConsuming application should use these reasons to customize escape key and/or backdrop click behavior.",
      "type": {
        "name": "func"
      },
      "required": false
    },
    "maxWidth": {
      "description": "The maximum width of the modal box. Use false for fullscreen.",
      "type": {
        "name": "enum",
        "value": [{
          "value": "'xs'",
          "computed": false
        }, {
          "value": "'sm'",
          "computed": false
        }, {
          "value": "'md'",
          "computed": false
        }, {
          "value": "'lg'",
          "computed": false
        }, {
          "value": "'xl'",
          "computed": false
        }, {
          "value": "false",
          "computed": false
        }]
      },
      "required": false
    },
    "primaryButton": {
      "description": "The primary button for the modal. This should be a @kyruus/button.\nThe embedding application should handle styling and click handling.",
      "type": {
        "name": "element"
      },
      "required": false
    },
    "secondaryButton": {
      "description": "The secondary button for the modal. This should be a @kyruus/button.\nThe embedding application should handle styling and click handling.",
      "type": {
        "name": "element"
      },
      "required": false
    },
    "title": {
      "description": "The title to go in the modal header",
      "type": {
        "name": "node"
      },
      "required": false
    },
    "subtitle": {
      "description": "A subtitle that will appear below the main title.",
      "type": {
        "name": "union",
        "value": [{
          "name": "string"
        }, {
          "name": "element"
        }]
      },
      "required": false
    },
    "useHeaderBorder": {
      "description": "Display the title within a header container.\nSet to false for confirmation modals.",
      "type": {
        "name": "bool"
      },
      "required": false
    },
    "allowContentOverflow": {
      "description": "Set to true if you want overflow content to be rendered outside and below the modal's bottom edge.",
      "type": {
        "name": "bool"
      },
      "required": false
    },
    "fullScreen": {
      "description": "If true, the dialog will be full-screen.",
      "type": {
        "name": "bool"
      },
      "required": false
    },
    "topAligned": {
      "description": "If true, the dialog will render at the top of its container.\nBy default, the dialog renders in the center of its container.",
      "type": {
        "name": "bool"
      },
      "required": false
    },
    "headerTestId": {
      "description": "If provided, the dialog header will have this prop applied as a data-testid attr.",
      "type": {
        "name": "string"
      },
      "required": false
    },
    "closeBtnTestId": {
      "description": "If provided, the dialog close button will have this prop applied as a data-testid attr.",
      "type": {
        "name": "string"
      },
      "required": false
    }
  }
};